import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LeadDisqualificationReasonRequest, LeadDisqualificationReasonResponse, PageResponse } from '../models/lead-disqualification-reason.model';

@Injectable({
  providedIn: 'root'
})
export class LeadDisqualificationReasonApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // GET /api/lead-disqualification-reasons?businessId=&page=&size=
  getReasons(businessId: number, page = 0, size = 100): Observable<LeadDisqualificationReasonResponse[]> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<LeadDisqualificationReasonResponse>>(`${this.apiUrl}/lead-disqualification-reasons`, { params })
      .pipe(map(res => res.content));
  }

  // GET /api/lead-disqualification-reasons/{id}?businessId=
  getReasonById(id: number, businessId: number): Observable<LeadDisqualificationReasonResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<LeadDisqualificationReasonResponse>(`${this.apiUrl}/lead-disqualification-reasons/${id}`, { params });
  }

  // POST /api/lead-disqualification-reasons
  createReason(reason: LeadDisqualificationReasonRequest): Observable<LeadDisqualificationReasonResponse> {
    return this.http.post<LeadDisqualificationReasonResponse>(`${this.apiUrl}/lead-disqualification-reasons`, reason);
  }

  // PUT /api/lead-disqualification-reasons/{id}
  updateReason(id: number, reason: LeadDisqualificationReasonRequest): Observable<LeadDisqualificationReasonResponse> {
    return this.http.put<LeadDisqualificationReasonResponse>(`${this.apiUrl}/lead-disqualification-reasons/${id}`, reason);
  }

  // DELETE /api/lead-disqualification-reasons/{id}?businessId=
  deleteReason(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/lead-disqualification-reasons/${id}`, { params });
  }
}
